import React from 'react';
import { Link } from 'react-router-dom';
import
    { FormGroup
    , Breadcrumbs
} from '@germix/germix-react-core';

import Application from '../components/app/Application';
import { withTranslation, WithTranslation } from 'react-i18next';

interface Props extends WithTranslation
{
}
interface State
{
}

/**
 * @author Germán Martínez
 */
class RouteLinks extends React.Component<Props,State>
{
    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/links'>{t('titles.links')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.links')}</h1>
    </FormGroup>
    <FormGroup>
        <a href="https://gtmetrix.com/" target="_target" title="GTmetrix | Website Speed and Performance Optimization">GTmetrix</a>
    </FormGroup>
</Application>
        )
    }
}
export default withTranslation('common')(RouteLinks);
